import React, { useState } from 'react';
import { theme } from '../styles/theme';
import './ImagePreviewModal.css';

/**
 * ImagePreviewModal - Shows image preview with caption input
 * Matches Flutter ImagePreviewModal design
 */
const ImagePreviewModal = ({ image, onSend, onCancel }) => {
  const [caption, setCaption] = useState('');
  const [imagePreview, setImagePreview] = useState(null);

  // Create preview URL
  React.useEffect(() => {
    if (image instanceof File) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(image);
    } else if (typeof image === 'string') {
      setImagePreview(image);
    }

    return () => {
      if (imagePreview && imagePreview.startsWith('blob:')) {
        URL.revokeObjectURL(imagePreview);
      }
    };
  }, [image]);

  const handleSend = () => {
    onSend(caption.trim() || 'image file');
  };

  return (
    <div className="image-preview-modal-overlay" onClick={onCancel}>
      <div className="image-preview-modal" onClick={(e) => e.stopPropagation()}>
        <div className="image-preview-header">
          <button className="cancel-button" onClick={onCancel}>✕</button>
          <h3>Send Image</h3>
        </div>
        
        <div className="image-preview-content">
          {imagePreview && (
            <img 
              src={imagePreview} 
              alt="Preview" 
              className="image-preview-img"
            />
          )}
          
          <div className="image-preview-caption">
            <input
              type="text"
              placeholder="Add a caption (optional)"
              value={caption}
              onChange={(e) => setCaption(e.target.value)}
              className="caption-input"
              style={{
                backgroundColor: theme.colors.background,
                color: theme.colors.text,
                border: `1px solid ${theme.colors.border}`,
              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSend();
                }
              }}
            />
          </div>
        </div>

        <div className="image-preview-footer">
          <button 
            className="send-button"
            onClick={handleSend}
            style={{
              backgroundColor: theme.colors.greenButton,
              color: 'white',
            }}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImagePreviewModal;



